module.exports = __webpack_public_path__ + "media/src/website/images/locations/eggstaett/profile-d04072555c7ebcdc8c5744f54f816aea.jpg";